import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { REVIEWS } from "@/data/site";

export const Testimonials = () => {
  const first = REVIEWS.slice(0, 5);
  const second = REVIEWS.slice(5);

  return (
    <section id="reviews" className="section bg-[#121212] border-y border-[#27272A] relative overflow-hidden">
      <div className="container-x mb-16">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div>
            <div className="text-xs uppercase tracking-[0.4em] text-accent mb-4">/ 04 Word of Mouth</div>
            <h2 className="font-display text-5xl sm:text-7xl text-white leading-none" data-testid="reviews-title">
              CLIENT
              <br />
              LOVE.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={20} className="fill-accent text-accent" />
              ))}
            </div>
            <div>
              <div className="font-display text-2xl text-white">5.0 / 5.0</div>
              <div className="text-xs uppercase tracking-[0.25em] text-dim">Average rating</div>
            </div>
          </div>
        </div>
      </div>

      <div className="marquee-fade space-y-6" data-testid="reviews-marquee">
        <Marquee gradient={false} speed={40} pauseOnHover>
          {first.map((r, i) => (
            <ReviewCard key={`a-${i}`} review={r} />
          ))}
        </Marquee>
        <Marquee gradient={false} speed={35} direction="right" pauseOnHover>
          {second.map((r, i) => (
            <ReviewCard key={`b-${i}`} review={r} />
          ))}
        </Marquee>
      </div>
    </section>
  );
};

const ReviewCard = ({ review }) => (
  <div className="bg-[#0A0A0A] border border-[#27272A] rounded-md p-7 mx-3 w-[360px] md:w-[420px] flex flex-col gap-4">
    <div className="flex items-center justify-between">
      <div className="flex">
        {Array.from({ length: review.rating }).map((_, i) => (
          <Star key={i} size={14} className="fill-accent text-accent" />
        ))}
      </div>
      <span className="text-[10px] uppercase tracking-[0.3em] text-dim">Verified</span>
    </div>
    <p className="text-white/85 leading-relaxed text-sm">"{review.text}"</p>
    <div className="flex items-center gap-3 mt-auto pt-3 border-t border-[#27272A]">
      <div className="w-9 h-9 rounded-full bg-accent/15 border border-accent/30 flex items-center justify-center text-accent font-bold text-sm">
        {review.name[0]}
      </div>
      <div>
        <div className="text-sm font-semibold text-white">{review.name}</div>
        <div className="text-[10px] uppercase tracking-[0.25em] text-dim">Lancaster, PA</div>
      </div>
    </div>
  </div>
);
